var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.491,
    height: 22,
    viewBox: "0 0 137.491 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49994",
    "data-name": "Group 49994",
    transform: "translate(-15593.771 -14154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93882",
    "data-name": "Path 93882",
    d: "M763.825,43.359a6.472,6.472,0,0,0,4.407-6.221c0-3.133-2.465-6.638-7.783-6.638h-6.888v22H758.3V43.814h.243l6.8,8.686h5.667ZM760.942,39.6h-2.83V35.052h2.83a2.284,2.284,0,1,1,0,4.552Z",
    transform: "translate(14960.253 14123.5)",
    fill: "#6e46ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93883",
    "data-name": "Path 93883",
    d: "M742.559,48.324V45.29h4.931V41.5h-4.931V38.462h6.448V34.29h-10.62V52.5h10.62V48.324Z",
    transform: "translate(14959.807 14123.5)",
    fill: "#6e46ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93884",
    "data-name": "Path 93884",
    d: "M729.664,52.5V38.462h4.172V34.29h-12.9v4.172h4.173L725.1,52.5Z",
    transform: "translate(14959.357 14123.5)",
    fill: "#6e46ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93885",
    "data-name": "Path 93885",
    d: "M710.858,52.5a9.069,9.069,0,0,1-6.608-2.61l2.306-3.217a6.658,6.658,0,0,0,4.157,1.737c1.465,0,1.889-.69,1.889-1.244s-.44-1.085-1.987-1.654l-1.366-.5c-2.511-.918-4.111-2.64-4.111-5.2,0-3.141,2.556-5.523,6.182-5.523a8.189,8.189,0,0,1,5.3,1.722l-2.162,3.315a5.883,5.883,0,0,0-3.019-.956c-1.267,0-1.844.531-1.844,1.168,0,.827.751,1.184,2.086,1.669l1.237.455c2.587.948,4.21,2.89,4.21,5.219,0,3.194-2.571,5.606-6.289,5.606",
    transform: "translate(14959.166 14123.5)",
    fill: "#6e46ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93886",
    "data-name": "Path 93886",
    d: "M699.7,34.29h-4.552v9.1l-10.621-9.1V52.5h4.552V43.773L699.7,52.5Z",
    transform: "translate(14958.718 14123.5)",
    fill: "#6e46ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93887",
    "data-name": "Path 93887",
    d: "M670.873,34.29a9.1,9.1,0,1,0,9.1,9.1A9.062,9.062,0,0,0,670.873,34.29Zm0,13.943a4.841,4.841,0,1,1,4.749-4.84A4.757,4.757,0,0,1,670.873,48.233Z",
    transform: "translate(14958.267 14123.5)",
    fill: "#00b6b4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93888",
    "data-name": "Path 93888",
    d: "M640.7,52.5V41.424l5.894,5.682,5.9-5.682V52.5h4.726v-22L646.595,40.726,635.975,30.5v22Z",
    transform: "translate(14957.796 14123.5)",
    fill: "#6e46ae",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster);
export default __webpack_public_path__ + "static/media/monster.26c2864e176f55b76cb4abe45590e3fd.svg";
export { ForwardRef as ReactComponent };